import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { colors, tilePalette } from "@/theme";
import { SectionTitle, Spinner } from "@/components/common";
import { useIsMobile } from "@/hooks/useMediaQuery";

export default function Gifts() {
  const [tab, setTab] = useState("person");
  const [persons, setPersons] = useState([]);
  const [occasions, setOccasions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    Promise.all([api("/gift-persons"), api("/gift-occasions")])
      .then(([p, o]) => { setPersons(p); setOccasions(o); })
      .finally(() => setLoading(false));
  }, []);

  const items = tab === "person" ? persons : occasions;
  const go = (item) => navigate(`/search?${tab === "person" ? "gift_person" : "gift_occasion"}=${item.id}&label=${encodeURIComponent(item.name)}`);

  return (
    <div className="container-max fade-up" style={{ padding: isMobile ? "24px 16px 40px" : "40px 24px 56px" }}>
      <SectionTitle eyebrow="Thoughtful Gifting" title="Gifts" subtitle="Find the perfect piece for every person & occasion." />
      <div style={{ display: "inline-flex", gap: 8, marginBottom: 28, background: colors.surfaceSecondary, padding: 5, borderRadius: 999 }}>
        <button data-testid="gifts-tab-person" className={`chip ${tab === "person" ? "chip-active" : ""}`} onClick={() => setTab("person")} style={{ background: tab === "person" ? colors.brand : "transparent" }}>By Person</button>
        <button data-testid="gifts-tab-occasion" className={`chip ${tab === "occasion" ? "chip-active" : ""}`} onClick={() => setTab("occasion")} style={{ background: tab === "occasion" ? colors.brand : "transparent" }}>By Occasion</button>
      </div>
      {loading ? <Spinner /> : (
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)", gap: isMobile ? 14 : 22 }}>
          {items.map((item, i) => (
            <button key={item.id} data-testid={`gift-${item.id}`} onClick={() => go(item)} className="card-hover" style={{ cursor: "pointer", border: `1px solid ${colors.border}`, background: tilePalette[i % tilePalette.length], borderRadius: 8, padding: isMobile ? "32px 16px" : "44px 20px", textAlign: "center" }}>
              <span className="font-display" style={{ fontSize: isMobile ? 20 : 24, fontWeight: 700, color: colors.onSurface }}>{item.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
